import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { Button } from '@material-ui/core';
import { activeMenu, activeMenuParent, selectMenu } from '@app/store/actions';
import { IMenuItem } from '@app/components/Sidebar/menuObject';
import { basicService } from '@app/services';
import { PasslyTooltip } from '@app/componentsV2';

interface IProps {
    item: IMenuItem;
    setIsCollapsed?: (isCollapsed: boolean) => void;
    isCollapsed?: boolean;
}

export const SidebarItemComponent = (props: IProps) => {
    const activeMenuId = useSelector((state: any) => state.sidebar.activeMenuId);
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();
    const { item, setIsCollapsed, isCollapsed } = props;

    const activateMenu = (item: IMenuItem) => (): void => {
        if (isCollapsed && setIsCollapsed) {
            setIsCollapsed(false);
        }
        basicService.redirect(item.link);
        dispatch(activeMenu(item.id));
        dispatch(activeMenuParent(item.parentId || 0));
    };

    const classes = (activeMenuId: number): string => {
        let classes: string = 'sidebar__item child';
        return activeMenuId === item.id ? (classes += ' sidebar__item--active') : classes;
    };

    // TODO: It fires on every call to item - so not only once, but fe 4,5,6 times (depending on a tree) - should be called only once
    useEffect(() => {
        if (item.parentId !== undefined) {
            dispatch(selectMenu(item.parentId));
        }
    }, []);

    return (
        <>
            {isCollapsed ? (
                <PasslyTooltip title={translation(item.name)} placement='right'>
                    <Button className={classes(activeMenuId)} onClick={activateMenu(item)}>
                        <div className='sidebar__item-icon'>{item.icon ? <i className={`icon-${item.icon}`} aria-hidden='true' /> : null}</div>
                        <div className='sidebar__item-name'>{translation(item.name)}</div>
                    </Button>
                </PasslyTooltip>
            ) : (
                <Button className={classes(activeMenuId)} onClick={activateMenu(item)}>
                    <div className='sidebar__item-icon'>{item.icon ? <i className={`icon-${item.icon}`} aria-hidden='true' /> : null}</div>
                    <div className='sidebar__item-name'>{translation(item.name)}</div>
                </Button>
            )}
        </>
    );
};
